import React, { useState, useEffect } from "react";
import Button from "../Components/Button";
import { ICON } from "../Utils";
import { MdClose, MdOutlineMenu } from "react-icons/md";

const Header = () => {
  const Links = [
    { name: "Home", link: "/" },
    { name: "Services", link: "/services" },
    { name: "Product", link: "/product" },
    { name: "Teams", link: "/teams" },
    { name: "About", link: "/about" },
    { name: "Blog's", link: "/blog" },
    { name: "Memories", link: "/memories" },
    { name: "Contact", link: "/contact" },
  ];

  const [open, setOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setScrollPosition(true);
    } else {
      setScrollPosition(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      <div
        className={`fixed top-0 w-full z-50 transition-all duration-500 ${
          scrollPosition
            ? "bg-white shadow-md text-black"
            : "bg-transparent text-white"
        }`}
      >
        <div className="md:flex items-center justify-between py-4 md:px-10 px-7">
          <div className="font-bold text-2xl cursor-pointer flex items-center">
            <img
              src={ICON.Logo}
              alt="Logo"
              className={`w-40 mx-8 cursor-pointer transition-all duration-300`}
            />
          </div>

          <div className="text-3xl absolute right-8 top-6 cursor-pointer md:hidden">
            <MdOutlineMenu
              size={24}
              className={scrollPosition ? "fill-black" : "fill-white"}
              data-te-offcanvas-toggle
              data-te-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
            />
          </div>

          <ul className="hidden md:flex items-center">
            {Links.map((link) => (
              <li key={link.name} className="md:ml-8 text-lg font-Argent">
                <a
                  href={link.link}
                  className={`transition-all duration-300 ${
                    scrollPosition ? "text-black" : "text-white"
                  }`}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        className="invisible fixed bottom-0 left-0 right-0 z-[1045] flex h-full translate-y-full flex-col bg-white shadow-md transition duration-300 ease-in-out [&[data-te-offcanvas-show]]:transform-none"
        id="offcanvasBottom"
        data-te-offcanvas-init
      >
        <div className="p-10">
          <div className="flex justify-end">
            <MdClose
              size={24}
              className="cursor-pointer"
              data-te-offcanvas-dismiss
            />
          </div>

          <ul className="mt-6">
            {Links.map((link) => (
              <li
                key={link.name}
                className="text-lg my-5 flex justify-center"
              >
                <a href={link.link} className="text-black font-Argent">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
